import __ from "src/utils/Translations";
import { BillingCyclePattern } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";
import formatDayLabel from "./formatDayLabel";

/**
 * Formats an array of day items into a comma-separated string with appropriate day labels
 *
 * @param daysArray - Array of objects containing value and id
 * @returns A string with values and their appropriate day labels joined by commas
 * @example
 */
export default (daysArray: BillingCyclePattern[] | undefined): string => {
  if (!daysArray || daysArray.length === 0) {
    return "";
  }

  return daysArray
    .map((item) => `${item.value} ${__(formatDayLabel(item.value))}`)
    .join(", ");
};
